import React, { useState, useEffect } from "react";
import ButtonFullWidth from "../ButtonFullWidth";
import {
    faCheck,
    faTimes,
    faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//import { CognitoIdentityServiceProvider } from "aws-sdk";

export default function S2Registration({
    handlePrevStep,
    handleNextStep,
    s1Form,
    handleGetSession,
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState(false);

    // Check API key on load
    useEffect(() => {
        let reportingUrl;
        let fecthRequest;
        if (s1Form.vendor === "SBM") {
            reportingUrl =
            "https://api.jungledrum.com/report?start_date=2023-06-12&end_date=" + new Date().toISOString();

            fecthRequest = {
                method: "GET",
                headers: {
                    "x-api-key": s1Form.apiKey,
                    "Content-Type": "application/json",
                },
            };
        } else {
            // Setting up request for replies from surveys
            reportingUrl =
                "https://api.messagemedia.com/v2-preview/reporting/messages/detail";

            const authString = s1Form.apiKey + ":" + s1Form.apiSecret;
            let base64AuthString;

            if (
                typeof window !== "undefined" &&
                typeof window.btoa === "function"
            ) {
                base64AuthString = window.btoa(authString);
            } else {
                const buffer = Buffer.from(authString, "utf-8");
                base64AuthString = buffer.toString("base64");
            }

            const headers = {
                Authorization: "Basic " + base64AuthString,
                "Content-Type": "application/json",
            };

            // Sending request
            const requestBody = {
                start_date: new Date(
                    new Date() - 30 * 24 * 60 * 60 * 1000
                ).toISOString(),
                end_date: new Date().toISOString(),
            };

            fecthRequest = {
                method: "POST",
                headers: headers,
                body: JSON.stringify(requestBody),
            };
        }
        console.log(reportingUrl);
        console.log(fecthRequest);
        fetch(reportingUrl, fecthRequest)
            .then((response) => {
                if (response.ok) {
                    console.log(
                        "Request successful (Status Code: " +
                            response.status +
                            ")"
                    );
                    setIsLoading(false);
                    setSuccess(true);
                    setMessage(
                        "Your API Key pair has been validated, please press Next to continue."
                    );
                } else {
                    console.log(
                        "Request failed (Status Code: " + response.status + ")"
                    );
                    setIsLoading(false);
                    setSuccess(false);
                    setMessage(
                        "Sorry, it appears that your API Key pair is invalid. Please try again."
                    );
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
                setSuccess(false);
                setMessage(
                    "Sorry, it appears that something went wrong, please try again later."
                );
            });
    }, []);

    return (
        <>
            <div className="flex items-center justify-center">
                {isLoading ? (
                    <div className="mb-12">
                        <div role="status" className="w-24 h-24">
                            <svg
                                aria-hidden="true"
                                className="text-gray-200 animate-spin dark:text-gray-600 fill-blue-600  transition-opacity duration-500"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 100 101"
                            >
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill"
                                />
                            </svg>
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div
                        role="status"
                        className="flex flex-col items-center gap-3 relative"
                    >
                        {success ? (
                            <>
                                <span className="flex items-center justify-center w-24 h-24 bg-green-200 rounded-full -left-4 transition-opacity duration-500">
                                    <div className="w-1/2 h-1/2">
                                        <FontAwesomeIcon
                                            aria-hidden="true"
                                            icon={faCheck}
                                            className="text-green-600"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />
                                    </div>
                                </span>
                                <span className="sr-only">successful</span>
                            </>
                        ) : (
                            <>
                                <span className="flex items-center justify-center w-24 h-24 bg-red-200 rounded-full -left-4 transition-opacity duration-500">
                                    <div className="w-1/2 h-1/2">
                                        <FontAwesomeIcon
                                            aria-hidden="true"
                                            icon={faTimes}
                                            className="text-red-600"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />
                                    </div>
                                </span>
                                <span className="sr-only">unsuccessful</span>
                            </>
                        )}
                        <p>{message}</p>
                    </div>
                )}
            </div>

            <div className="flex gap-x-5 mx-12">
                <ButtonFullWidth
                    type="button"
                    message="Previous"
                    action={handlePrevStep}
                />
                <ButtonFullWidth
                    type="button"
                    message="Next"
                    action={handleNextStep}
                    applyClassName={!success}
                    className={"border-gray-500 text-gray-500"}
                    disabled={!success}
                />
            </div>
        </>
    );
}
